// extracted by mini-css-extract-plugin
export var marginNegative = "_5r-5 _5r-3 _5r-1";
export var marginPositive = "_5r-4 _5r-3 _5r-1";
export var modalContent = "_5r-6";
export var samplesTable = "_5r-8";
export var samplesTableContainer = "_5r-7";
export var statBox = "_5r-a";
export var tableCell = "_5r-1";
export var tableCellCenter = "_5r-2 _5r-1";
export var tableCellRight = "_5r-3 _5r-1";
export var tableHeader = "_5r-0";
export var trackingNumber = "_5r-9";